import styled from "styled-components";

const Col = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export default Col;
